import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserResponse } from 'src/app/core/models/user';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit, OnDestroy {
  user: UserResponse | undefined;
  private subscription = new Subscription();
  constructor(
    private _authService: AuthenticationService
  ) {

  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    // this.subscription.add(
    //   this._authService.getProfile().subscribe(
    //     {
    //       next: (user: UserResponse) => {
    //         this.user = user;
    //       }
    //     }
    //   )
    // );
  } 
}
